import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, BatchTransactionDialogueHandler } from '../types';
import BatchTransactionDialogueContext from './BatchTransactionContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type BatchTransactionDialogueProps = {
  handleDialogue: DialogueHandler<BatchTransactionDialogueHandler>;
};

type FC = FunctionComponent<BatchTransactionDialogueProps>;

const BatchTransactionDialogue: FC = ({ handleDialogue }: BatchTransactionDialogueProps) => {
  const { showBatchTransactionErrorAlert, batchTransactionError } = useContext(BatchTransactionDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Details.Contacts.BatchTransactionError' });

  return useMemo(
    () => (
      <div>
        {/* Batch Transaction Error */}
        <ConfirmationDialogue
          isVisible={showBatchTransactionErrorAlert}
          title={t('title')}
          status="error"
          subTitle={`${batchTransactionError}`}
          confirm={{
            label: t('confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showBatchTransactionErrorAlert, batchTransactionError],
  );
};

export default BatchTransactionDialogue;
